import React from 'react';

import { useLocation } from 'react-router-dom';
import { useCimbeo } from '../../context';

import AnalyticsNavbar from './AnalyticsNavBar';
import ProjectsNavBar from './ProjectsNavBar';

function Navbar() {
    const location = useLocation();
    const { projectName } = useCimbeo();
    
    const smallNavBarPages = [
        "/projects", "/home", "project-management"
    ];

    // Display different navbars based on the page. Should display navbar with no project options if no project is selected,
    // or if the user is changing projects / project information.
    const NavBarComponent = smallNavBarPages.includes(location.pathname) || projectName == "" ? ProjectsNavBar : AnalyticsNavbar

    return (
        <NavBarComponent />
    )
}

export default Navbar;